import { Flex, Text, Link, IconButton } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as CloseIcon } from 'resources/images/close.svg';
import { emptyStateBtnSx, emptyStateRootSx } from './styles';

interface EmptyStateProps {
  onClose: React.MouseEventHandler<HTMLButtonElement>;
}

export const EmptyState = ({ onClose }: EmptyStateProps) => (
  <Flex sx={emptyStateRootSx} data-testid="pinned-songs-section-empty">
    <IconButton
      aria-label="close pin section"
      variant="text"
      size="xs"
      icon={<CloseIcon />}
      data-testid="pinSongSection-close-button"
      onClick={onClose}
      sx={emptyStateBtnSx}
    />
    <Text fontSize="md" fontWeight="medium">
      Highlight your most important Songs
    </Text>
    <Text fontSize="xs" color="M.60" mt={1}>
      Pin Songs for easy access.{' '}
      <Link
        as={NavLink}
        target="_blank"
        to="https://support.sessionstudio.com/en/articles/8954286-pinned-songs"
      >
        Learn more
      </Link>
    </Text>
  </Flex>
);
